enum HuonekorttiSortEnum {
    id = "id",
    tilanimike = "tilanimike",
    tasmennys = "tasmennys",
    status = "status",
    vastuuyksikko = "vastuuyksikko",
}

export default HuonekorttiSortEnum
